/**
 * Base64 for binary update payloads.
 *
 * Jazz 0.x has no binary column, so update bytes travel as strings. Both
 * consumers run somewhere `btoa`/`atob` exist (browsers, and Node >= 16), so
 * no polyfill and no `Buffer` — the latter would not survive the bundler.
 */

/**
 * Bytes per `String.fromCharCode` call. Spreading a whole update would blow
 * the argument limit on a large document; 8 KiB is comfortably under every
 * engine's cap and keeps the loop short.
 */
const CHUNK = 0x2000;

export function bytesToBase64(bytes: Uint8Array): string {
  let binary = "";
  for (let i = 0; i < bytes.length; i += CHUNK) {
    binary += String.fromCharCode(...bytes.subarray(i, i + CHUNK));
  }
  return btoa(binary);
}

export function base64ToBytes(encoded: string): Uint8Array {
  const binary = atob(encoded);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) bytes[i] = binary.charCodeAt(i);
  return bytes;
}
